<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="300"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        rounded
        outlined
        color="green darken-3"
        style="text-transform: capitalize;"
      >
        {{ $t("seeGames") }} ({{ games.length }})
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense>
        <span>{{$t("games")}} ({{ games.length }})</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5 body-2">
        <ul>
          <li v-for="(game, index) in games" :key="index">
            {{ game.game_name }}
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "SeeGames",
  props: ["games"],
  data: () => ({
    dialog: false,
  }),
}
</script>
<style>
li {
  color: #E0E0E0;
  list-style: square;
}
</style>